import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { refUrl } from "@/lib/api";

const DOT = {
  service: "bg-[#16385f]",
  company: "bg-[#0b6b3a]",
  category: "bg-[#b1560f]",
};

export default function RelatedGrid({ title, items = [], testid, cols = 2 }) {
  if (!items || items.length === 0) return null;
  const grid = cols === 3 ? "sm:grid-cols-2 lg:grid-cols-3" : "sm:grid-cols-2";
  return (
    <section className="mt-10" data-testid={testid}>
      <h2 className="mb-3 border-b-2 border-[var(--line)] pb-2 text-xl font-bold text-[var(--navy)]">
        {title}
        <span className="ml-2 text-sm font-semibold text-[var(--muted)]">({items.length})</span>
      </h2>
      <div className={`grid grid-cols-1 gap-2 ${grid}`}>
        {items.map((it) => (
          <Link
            key={`${it.type}-${it.slug}`}
            to={refUrl(it)}
            data-testid={`related-${it.type}-${it.slug}`}
            className="card-hover group flex items-center gap-2 rounded-[5px] border border-[var(--line)] bg-white px-3 py-2.5 no-underline"
          >
            <span className={`h-2 w-2 shrink-0 rounded-full ${DOT[it.type] || "bg-slate-400"}`} />
            <span className="flex-1 text-sm font-semibold text-[var(--ink)] group-hover:text-[var(--gov-blue)]">
              {it.name}
            </span>
            <ArrowUpRight
              size={15}
              className="text-[var(--line)] transition-colors group-hover:text-[var(--gov-blue)]"
            />
          </Link>
        ))}
      </div>
    </section>
  );
}
